import { connect } from 'react-redux';
import { selectors } from 'state/selectors';
import { mapStateToPropsTestUtil } from './connectTestUtil';

export const connectTestUtil = connect(mapStateToPropsTestUtil(selectors));
